import Highcharts from 'highcharts';
import React, { useEffect } from 'react';
import HighchartsReact from 'highcharts-react-official';
import { ADD_RESPONSE } from '../../../../stores/reducer_add';
import { ADD_HIS_ALERTS } from '../../../../stores/reducer_HistoryData';
import { useAppDispatch, useAppSelector } from '../../../../stores/hooks';
import { useTranslation } from 'react-i18next';

interface TimeIntervalCount {
  sit: number;
  lyingDown: number;
  notInBed: number;
  turnover: number;
  sitUpCountDayTimesArr: number[];
  lieDownCountDayTimesArr: number[];
  leaveBedCountDayTimesArr: number[];
  turnOverCountDayTimesArr: number[];
  sitUpCountNightTimesArr: number[];
  lieDownCountNightTimesArr: number[];
  leaveBedCountNightTimesArr: number[];
  turnOverCountNightTimesArr: number[];
}
interface SeriesType {
  name: string;
  data: (number | null)[];
  type?: string;
  color?: string;
  yAxis?: number;
  marker?: {
    enabled: boolean;
    states?: {
      hover: {
        enabled: boolean;
      };
    };
  };
  dataLabels?: {
    enabled: boolean;
  };
  tooltip?: {
    enabled: boolean;
  };
  dashStyle?: string;
  visible?: boolean;
}
interface propsIF {
  timesValuesData: number[];
  observationValuesData: number[];
  timeIntervalCount: {};
  daySwitch:string;
}


const HisAlertColumnByDays = ({ timesValuesData, observationValuesData, timeIntervalCount, daySwitch }: propsIF): React.JSX.Element => {
    // ------- redux --------------------
    const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const store_timestamp = useAppSelector((state) => state.store_historyData.timestamp);
  const chartRef = React.useRef<HighchartsReact.RefObject>(null);
  const { sitDay, lyingDownDay, notInBedDay, turnoverDay, sitNight, lyingDownNight, notInBedNight, turnoverNight } = processTimeIntervalCount(timeIntervalCount as TimeIntervalCount);
  const currentDate = new Date(store_timestamp);
  const xAxis = getDatesArray(currentDate);

  // const highchart_data_fromat: SeriesType[] = [
  //   { name: t('HISTORY_RECORD.MOBILITY_SIT_COUNT'), data: sitDay ?? [], color: '#fbbc04' },
  //   { name: t('HISTORY_RECORD.MOBILITY_SIT_COUNT'), data: sitNight ?? [], color: '#fbbc04' },
  //   { name: t('HISTORY_RECORD.MOBILITY_LIE'), data: lyingDownDay ?? [], color: '#34a853' },
  //   { name: t('HISTORY_RECORD.MOBILITY_LIE'), data: lyingDownNight ?? [], color: '#34a853' },
  //   { name: t('HISTORY_RECORD.MOBILITY_NIB'), data: notInBedDay ?? [], color: '#4285f4' },
  //   { name: t('HISTORY_RECORD.MOBILITY_NIB'), data: notInBedNight ?? [], color: '#4285f4' },
  //   { name: t('HISTORY_RECORD.MOBILITY_ROLL'), data: turnoverDay ?? [], color: '#ffab91' },
  //   { name: t('HISTORY_RECORD.MOBILITY_ROLL'), data: turnoverNight ?? [], color: '#ffab91' },
  // ];
    const highchart_data_fromat: SeriesType[] = [
      // 坐起
      ...(daySwitch === 'day'
        ? [
            {
              name: t('HISTORY_RECORD.MOBILITY_SIT_COUNT') + ' (Day)',
              data: sitDay ?? [],
              color: '#fdd76a',
              type: 'column',
            },
          ]
        : []),
      ...(daySwitch === 'night'
        ? [
            {
              name: t('HISTORY_RECORD.MOBILITY_SIT_COUNT') + ' (Night)',
              data: sitNight ?? [],
              color: '#fbbc04',
              type: 'column',
            },
          ]
        : []),

      // 躺下
      ...(daySwitch === 'day'
        ? [
            {
              name: t('HISTORY_RECORD.MOBILITY_LIE') + ' (Day)',
              data: lyingDownDay ?? [],
              color: '#6fc686',
              type: 'column',
            },
          ]
        : []),
      ...(daySwitch === 'night'
        ? [
            {
              name: t('HISTORY_RECORD.MOBILITY_LIE') + ' (Night)',
              data: lyingDownNight ?? [],
              color: '#34a853',
              type: 'column',
            },
          ]
        : []),

      // 離床
      ...(daySwitch === 'day'
        ? [
            {
              name: t('HISTORY_RECORD.MOBILITY_NIB') + ' (Day)',
              data: notInBedDay ?? [],
              color: '#7dadff',
              type: 'column',
            },
          ]
        : []),
      ...(daySwitch === 'night'
        ? [
            {
              name: t('HISTORY_RECORD.MOBILITY_NIB') + ' (Night)',
              data: notInBedNight ?? [],
              color: '#4285f4',
              type: 'column',
            },
          ]
        : []),

      // 翻身
      ...(daySwitch === 'day'
        ? [
            {
              name: t('HISTORY_RECORD.MOBILITY_ROLL') + ' (Day)',
              data: turnoverDay ?? [],
              color: '#ffc7b6',
              type: 'column',
            },
          ]
        : []),
      ...(daySwitch === 'night'
        ? [
            {
              name: t('HISTORY_RECORD.MOBILITY_ROLL') + ' (Night)',
              data: turnoverNight ?? [],
              color: '#ffab91',
              type: 'column',
            },
          ]
        : []),
    ];

  if (daySwitch === 'all' && timesValuesData.some((value) => value !== 0)) {
    highchart_data_fromat.push({
      name: t('HISTORY_RECORD.MOBILITY_COUNT'),
      data: timesValuesData,
      type: 'line',
      color: '#00acc1',
      yAxis: 1,
      marker: { enabled: false },
      dataLabels: { enabled: false },
      tooltip: {
        enabled: false,
      },
    });
  }
  if (daySwitch === 'all' && observationValuesData.some((value) => value !== 0)) {
    highchart_data_fromat.push({
      name: t('HISTORY_RECORD.MOBILITY_VALUE'),
      data: observationValuesData,
      type: 'line',
      color: '#9575cd',
      yAxis: 2,
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false,
          },
        },
      },
      tooltip: {
        enabled: false,
      },
      dataLabels: { enabled: false },
    });
  }
  const chart = {
    chart: { type: 'column', backgroundColor: '#dbfdff', borderRadius: 10 },
    exporting: { enabled: false },
    title: {
      text: t('HISTORY_RECORD.MOBILITY_TEXT') + (daySwitch === 'day' ? ' (Day)' : daySwitch === 'night' ? ' (Night)' : ''),
    },
    xAxis: {
      type: 'datetime',
      categories: xAxis,
    },
    yAxis: [
      {
        min: 0,
        startOnTick: false,
        endOnTick: false,
        opposite: true,
        gridLineColor: 'transparent',
        labels: {
          enabled: false,
        },
        title: { text: '' },
      },
      {
        min: 0,
        maxPadding: 0.2,
        startOnTick: false,
        endOnTick: true,
        opposite: false,
        gridLineColor: 'transparent',
        labels: {
          enabled: true,
          formatter: function (this: Highcharts.AxisLabelsFormatterContextObject): string {
            if (this.value === this.axis.min) {
              return t('HISTORY_RECORD.MOBILITY_SMALL');
            } else if (this.value === this.axis.max) {
              return t('HISTORY_RECORD.MOBILITY_LARGE');
            }
            return '';
          },
        },
        title: { text: t('HISTORY_RECORD.MOBILITY_INTENSITY') },
      },
      {
        min: 0,
        startOnTick: false,
        endOnTick: false,
        opposite: false,
        gridLineColor: 'transparent',
        labels: {
          enabled: false,
          formatter: function (this: Highcharts.AxisLabelsFormatterContextObject): string {
            return this.value === this.axis.min ? t('HISTORY_RECORD.MOBILITY_SMALL') : t('HISTORY_RECORD.MOBILITY_LARGE');
          },
        },
        title: { text: '' },
      },
    ],
    legend: {
      align: 'right',
      x: -0,
      verticalAlign: 'top',
      y: 20,
      floating: true,
      backgroundColor: Highcharts.defaultOptions.legend?.backgroundColor || 'white',
      borderColor: '#CCC',
      borderWidth: 1,
      shadow: false,
      symbolWidth: 12,
      symbolHeight: 12,
      symbolRadius: 0,
    },
    tooltip: {
      // headerFormat: '<b>{point.x}</b><br/>',
      // pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
      useHTML: true,
      formatter: function (this: Highcharts.TooltipFormatterContextObject): string | false {
        const color = (this.series.options as any).color;
        const stackTotal = (this.point as Highcharts.Point & { stackTotal?: number }).stackTotal;
        if (this.series.type === 'column' && stackTotal !== undefined) {
          return `<span><b>${this.x}</b><br/><span style="color:${color}; font-size: 10px;">■ </span>${this.series.name}: ${this.y}</span>`;
        }
        return false;
      },
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: true,
        },
      },
      line: {
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
        tooltip: {
          enabled: false,
        },
      },
    },
    series: highchart_data_fromat,
  };

  return (
    <>
      <div className="w-100 h-100">
        <HighchartsReact highcharts={Highcharts} options={chart} allowChartUpdate={true} containerProps={{ className: 'w-100 h-100' }} />
      </div>
    </>
  );
};
export default HisAlertColumnByDays;

//整理4項指標資料轉為陣列
function processTimeIntervalCount(data: TimeIntervalCount) {
  if (!data) return { sit: [], lyingDown: [], notInBed: [], turnover: [] };
  const { sitUpCountDayTimesArr: sitDay = [], lieDownCountDayTimesArr: lyingDownDay = [], leaveBedCountDayTimesArr: notInBedDay = [], turnOverCountDayTimesArr: turnoverDay = [], sitUpCountNightTimesArr: sitNight = [], lieDownCountNightTimesArr: lyingDownNight = [], leaveBedCountNightTimesArr: notInBedNight = [], turnOverCountNightTimesArr: turnoverNight = [] } = data;

  const processArray = (arr: number[] | undefined) => {
    if (!Array.isArray(arr)) return [];
    return arr.map((val) => (val === 0 ? null : val));
  };

  return {
    sitDay: processArray(sitDay),
    lyingDownDay: processArray(lyingDownDay),
    notInBedDay: processArray(notInBedDay),
    turnoverDay: processArray(turnoverDay),
    sitNight: processArray(sitNight),
    lyingDownNight: processArray(lyingDownNight),
    notInBedNight: processArray(notInBedNight),
    turnoverNight: processArray(turnoverNight),
  };
}

// 計算日期陣列
const getDatesArray = (currentDate: Date): string[] => {
  const dates = [];
  const totalDays = 30;
  const middleIndex = 29;

  // 先計算當前日期前的日期
  for (let i = middleIndex; i >= 0; i--) {
    const date = new Date(currentDate);
    date.setDate(date.getDate() - (middleIndex - i));
    dates[i] = `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
  }

  // 再計算當前日期後的日期
  for (let i = middleIndex + 1; i < totalDays; i++) {
    const date = new Date(currentDate);
    date.setDate(date.getDate() + (i - middleIndex));
    dates[i] = `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
  }

  return dates;
};
